import { render } from "./remark-section.vue?vue&type=template&id=261a0eb8&ts=true"
import script from "./remark-section.vue?vue&type=script&lang=ts"
export * from "./remark-section.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__